import { useState } from 'react'
import { Outlet } from 'react-router'
import classNames from 'classnames'

import { useInitData, useLogin, useUserData } from '../../hooks'
import { isWorkerUser } from '../../utils/user'
import { Loader } from '../Loader'
import { Menu } from '../Menu'
import { UserMenuLogoutOnly } from '../User'

import { LayoutHeader } from './LayoutHeader'
import { LayoutMain } from './LayoutMain'
import { LayoutOverlay } from './LayoutOverlay'
import { LayoutProviders } from './LayoutProviders'

import * as styles from './Layout.module.css'

function Layout({ className = styles.Layout, getMenuItems }) {
  const initData = useInitData()
  const { authorized } = initData
  const userData = useUserData()

  const [isOpenHeaderSearch, setIsOpenHeaderSearch] = useState(false)

  const menuItems = getMenuItems({
    permissions: initData.permissions,
    sectionsPermissions: initData.sections,
    uiSections: initData.availableSections,
    ukConfig: initData.uk.config,
    userData,
    userRole: userData?.role,
  })

  useLogin()

  const isWorker = !!userData && isWorkerUser(userData)

  return authorized ? (
    <LayoutProviders>
      <LayoutOverlay />
      <div
        className={classNames(className, {
          [styles.headerSearchOpen]: isOpenHeaderSearch,
        })}
      >
        <Menu
          LogoLink={isWorker ? null : undefined}
          className={styles.menu}
          items={menuItems}
        />
        <LayoutMain className={styles.main}>
          <LayoutHeader
            {...(isWorker
              ? {
                  AddEntityButton: null,
                  Help: null,
                  Search: null,
                  SearchButton: null,
                  UserMenu: UserMenuLogoutOnly,
                }
              : null)}
            isOpenSearch={isOpenHeaderSearch}
            onSetOpenSearch={setIsOpenHeaderSearch}
          />
          <Outlet />
        </LayoutMain>
      </div>
    </LayoutProviders>
  ) : (
    <Loader />
  )
}

export default Layout
